export default "__VITE_ASSET__BBurtQQe__"